import React from 'react';

// styles
import './ycAvatar.scss';

type Props = {
  img: *,
  title: string,
  active: boolean,
};

export class YcAvatar extends React.PureComponent<Props> {
  render() {
    const { img } = this.props;
    return (
      <div className="c-avatar">
        <img className="avatar" src={img} alt="back ground avatar" />
      </div>
    );
  }
}
